/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-08-20 14:10:13
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-08-30 15:25:05
 */
import store from "@/store";

/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export function checkPermission(value) {
  if (value && value instanceof Array && value.length > 0) {
    const roles = store.getters && store.getters.permissions;
    const permissionRoles = value;

    const hasPermission = roles.some(role => permissionRoles.includes(role));
    return hasPermission;
  } else {
    console.error(`need roles! Like v-if="checkPermission['admin','editor']"`);
    return false;
  }
}
/**
 * 本组织权限
 * @param {*} value
 * @returns
 */
export function checkOrgPermission(value, type = "") {
  const orgId = store.getters && store.getters.infoData ? store.getters.infoData.belongOrgId : "";
  let pass = true;
  if (value) {
    switch (type) {
      case "user":
        pass = value.id && value.id === orgId;
        break;
      default:
        pass = orgId === value;
    }
  }
  return pass;
}
